import { Component, inject } from '@angular/core';
import {UserService} from "../../../core/user/services/user.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-idf-select-dialog',
  imports: [MatRadioModule, MatButtonModule],
  templateUrl: './idf-select-dialog.component.html',
  styleUrl: './idf-select-dialog.component.scss'
})
export class IdfSelectDialogComponent {
  selectedIdf: any;
  readonly userService: UserService = inject(UserService);
  readonly dialogRef = inject(MatDialogRef<any>);
  readonly data = inject<any>(MAT_DIALOG_DATA)

  closeDialog() {
    this.dialogRef.close(this.selectedIdf);
  }
}
